<template>
	<article class="dictionary">
		<managing-section>
			<managing-box title="필터">
				<RadioList
					v-model="type"
					:radio-list="typeList"
					@input="changeType"
				/>
			</managing-box>
		</managing-section>
		<managing-section :is-table="true">
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td>{{ idx + 1 + page * limit }}</td>
						<td class="dictionary__table__value">
							{{ item.value }}
						</td>
						<td>{{ item.ty }}</td>
						<td>{{ item.sortNo }}</td>
						<td>{{ item.idProduct }}</td>
						<td>{{ item.isLinked ? '연결어' : '' }}</td>
						<td>{{ item.isCustom ? '추가' : '' }}</td>
					</tr>
				</tbody>
			</table>
			<div class="dictionary__pagination" slot="pagination">
				<button
					class="btn-main"
					type="button"
					@click="prev"
					:disabled="isDiabledPrevBtn"
				>
					이전
				</button>
				<button
					class="btn-main blue"
					type="button"
					@click="next"
					:disabled="isDiabledNextBtn"
				>
					다음
				</button>
			</div>
		</managing-section>
	</article>
</template>

<script>
	import _ from 'lodash';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'Dictionary',
		components: { ManagingSection, ManagingBox, RadioList, PaginationBox },
		data() {
			return {
				type: 'all',
				typeList: [
					{ id: 'all', value: '전체' },
					{ id: 'positive', value: '긍정어' },
					{ id: 'negative', value: '부정어' },
					{ id: 'undefined', value: 'UNDEFINED' },
					{ id: 'brand', value: '브랜드' },
					{ id: 'product', value: '제품' },
				],
				thList: [
					'#',
					'내용',
					'타입',
					'타입항번',
					'제품항번',
					'연결어',
					'추가',
				],
				list: [],
				page: 0,
				pageData: [],
				limit: 100,
			};
		},
		computed: {
			isDiabledPrevBtn() {
				return !this.pageData[this.page - 1];
			},
			isDiabledNextBtn() {
				return !this.pageData[this.page + 1];
			},
		},
		created() {
			this.page = 0;
			this.pageData = [
				{
					page: 0,
				},
			];
			this.setFilter();
			this.getList();
		},
		methods: {
			getParams() {
				const params = {};
				const pageData = this.pageData[this.page];
				if (this.type !== 'all') params.type = this.type;
				if (pageData.lastTy && pageData.lastSortNo) {
					params.lastTy = pageData.lastTy;
					params.lastSortNo = pageData.lastSortNo;
				}
				return params;
			},
			async getList() {
				try {
					const params = this.getParams();
					const { data } = await this.$axiosAdmin2.get(
						'/api/analysis/reviews/dict',
						{ params }
					);
					this.list = data.dictItems;
					if (data.lastTy && data.lastSortNo) {
						this.pageData.push({
							page: this.page + 1,
							lastTy: data.lastTy,
							lastSortNo: data.lastSortNo,
						});
					}
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			changeFilter() {
				const query = {};
				if (this.type !== 'all') query.type = this.type;
				if (this.lastTyPrev) query.lastTyPrev = this.lastTyPrev;
				if (this.lastSortNoPrev)
					query.lastSortNoPrev = this.lastSortNoPrev;
				if (this.lastTyNext) query.lastTyNext = this.lastTyNext;
				if (this.lastSortNoNext)
					query.lastSortNoNext = this.lastSortNoNext;
				if (_.isEqual(this.$route.query, query)) {
					window.location.reload();
					return;
				}
				this.$router.replace({ query });
				this.getList();
			},
			changeType() {
				this.page = 0;
				this.pageData = [
					{
						page: 0,
					},
				];
				this.changeFilter();
			},
			prev() {
				this.page--;
				this.getList();
			},
			next() {
				this.page++;
				this.getList();
			},
			setFilter() {
				this.type = this.$route.query.type || 'all';
				this.lastTyPrev = this.$route.query.lastTyPrev || '';
				this.lastSortNoPrev = this.$route.query.lastSortNoPrev || '';
				this.lastTyNext = this.$route.query.lastTyNext || '';
				this.lastSortNoNext = this.$route.query.lastSortNoNext || '';
			},
		},
	};
</script>

<style lang="scss">
	.dictionary--page {
		.dictionary__table__value {
			text-align: left;
		}

		.dictionary__pagination {
			text-align: right;
		}
	}
</style>
